import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as MdIcons from "react-icons/md";
import * as BsIcons from "react-icons/bs";
import * as GiIcons from "react-icons/gi";
import * as RiIcons from "react-icons/ri";

const AllIcons = {
  ...FaIcons,
  ...AiIcons,
  ...IoIcons,
  ...MdIcons,
  ...BsIcons,
  ...GiIcons,  
  ...RiIcons,
};

export default AllIcons;
